export enum CategorisationStatus {
  Pending = 'PENDING',
  Referred = 'REFERRED',
  Failed = 'FAILED',
  Passed = 'PASSED',
}
